var _path, _g, _path2, _g2, _path3, _path4, _path5, _g3, _path6, _g4, _path7, _g5, _path8, _g6, _path9, _g7, _path10, _g8, _g9, _g10, _g11, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g12, _path19, _g13, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutusCircle1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 264,
    viewBox: "0 0 285 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_539_1250",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 22,
    width: 235,
    height: 235
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M275.902 139.276C275.902 203.803 223.522 256.191 158.846 256.191C94.2414 256.191 41.79 203.874 41.79 139.276C41.79 74.7491 94.1703 22.3608 158.846 22.3608C223.522 22.3608 275.902 74.6781 275.902 139.276Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_539_1250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.999 0H26.0117V207.14H284.999V0Z",
    fill: "#8C9FA5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_539_1250",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 22,
    width: 235,
    height: 235
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M275.902 139.276C275.902 203.803 223.522 256.191 158.846 256.191C94.2414 256.191 41.79 203.874 41.79 139.276C41.79 74.7491 94.1703 22.3608 158.846 22.3608C223.522 22.3608 275.902 74.6781 275.902 139.276Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_539_1250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.999 171.859H26.0117V263.929H284.999V171.859Z",
    fill: "#7D8B8E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_539_1250",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 22,
    width: 235,
    height: 235
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M275.902 139.276C275.902 203.803 223.522 256.191 158.846 256.191C94.2414 256.191 41.79 203.874 41.79 139.276C41.79 74.7491 94.1703 22.3608 158.846 22.3608C223.522 22.3608 275.902 74.6781 275.902 139.276Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_539_1250)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M152.52 21.083H17.2698V160.43H152.52V21.083Z",
    fill: "#E9FDFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_539_1250",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 21,
    width: 136,
    height: 140
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M152.52 21.083H17.2698V160.43H152.52V21.083Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_539_1250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.065 32.6538H113.573V62.9652H115.065V32.6538Z",
    fill: "#88A3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.141 32.6538H112.649V62.9652H114.141V32.6538Z",
    fill: "#B3CDE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.523 51.6074H109.877V76.8077H123.523V51.6074Z",
    fill: "#88A3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.614 51.6074H105.968V76.8077H119.614V51.6074Z",
    fill: "#B3CDE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.99 66.7275H106.892V91.9279H129.99V66.7275Z",
    fill: "#88A3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.451 66.7275H100.353V91.9279H123.451V66.7275Z",
    fill: "#B3CDE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.681 84.6162H105.044V161.353H134.681V84.6162Z",
    fill: "#88A3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.295 84.6162H96.6575V161.353H126.295V84.6162Z",
    fill: "#B3CDE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.452 53.8081H109.735V54.8019H123.452V53.8081Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.685 53.8081H105.968V54.8019H119.685V53.8081Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.452 56.5054H109.735V57.4992H123.452V56.5054Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.685 56.5054H105.968V57.4992H119.685V56.5054Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.452 59.2031H109.735V60.1969H123.452V59.2031Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.685 59.2031H105.968V60.1969H119.685V59.2031Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.452 61.8296H109.735V62.8234H123.452V61.8296Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.685 61.8296H105.968V62.8234H119.685V61.8296Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.452 64.5269H109.735V65.5207H123.452V64.5269Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.685 64.5269H105.968V65.5207H119.685V64.5269Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.919 67.9341H106.678V68.9279H129.919V67.9341Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.593 67.9341H100.353V68.9279H123.593V67.9341Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.919 70.8447H106.678V71.8385H129.919V70.8447Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.593 70.8447H100.353V71.8385H123.593V70.8447Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.919 73.8262H106.678V74.82H129.919V73.8262Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.593 73.8262H100.353V74.82H123.593V73.8262Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.919 76.7363H106.678V77.7301H129.919V76.7363Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.593 76.7363H100.353V77.7301H123.593V76.7363Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.919 79.647H106.678V80.6408H129.919V79.647Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.593 79.647H100.353V80.6408H123.593V79.647Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.919 82.5576H106.678V83.5514H129.919V82.5576Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.593 82.5576H100.353V83.5514H123.593V82.5576Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.61 87.1006H104.83V88.0944H134.61V87.1006Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.437 87.1006H96.6575V88.0944H126.437V87.1006Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.61 91.5728H104.83V92.5666H134.61V91.5728Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.437 91.5728H96.6575V92.5666H126.437V91.5728Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.61 96.0449H104.83V97.0387H134.61V96.0449Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.437 96.0449H96.6575V97.0387H126.437V96.0449Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.61 100.588H104.83V101.582H134.61V100.588Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.437 100.588H96.6575V101.582H126.437V100.588Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.61 105.061H104.83V106.054H134.61V105.061Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.437 105.061H96.6575V106.054H126.437V105.061Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.61 109.604H104.83V110.597H134.61V109.604Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.437 109.604H96.6575V110.597H126.437V109.604Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.61 114.076H104.83V115.07H134.61V114.076Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.437 114.076H96.6575V115.07H126.437V114.076Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.61 118.619H104.83V119.612H134.61V118.619Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.437 118.619H96.6575V119.612H126.437V118.619Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.61 123.091H104.83V124.085H134.61V123.091Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.437 123.091H96.6575V124.085H126.437V123.091Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.61 127.634H104.83V128.628H134.61V127.634Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.437 127.634H96.6575V128.628H126.437V127.634Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.61 132.106H104.83V133.1H134.61V132.106Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.437 132.106H96.6575V133.1H126.437V132.106Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.61 136.649H104.83V137.643H134.61V136.649Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.437 136.649H96.6575V137.643H126.437V136.649Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.61 141.122H104.83V142.115H134.61V141.122Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.437 141.122H96.6575V142.115H126.437V141.122Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.61 145.594H104.83V146.588H134.61V145.594Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.437 145.594H96.6575V146.588H126.437V145.594Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.61 150.137H104.83V151.131H134.61V150.137Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.437 150.137H96.6575V151.131H126.437V150.137Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.61 154.609H104.83V155.603H134.61V154.609Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.437 154.609H96.6575V155.603H126.437V154.609Z",
    fill: "#AEC1CE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_539_1250",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 21,
    width: 136,
    height: 140
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M152.52 21.083H17.2698V160.43H152.52V21.083Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_539_1250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.214 116.418H95.3782V161.566H128.214V116.418Z",
    fill: "#91A0A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.612 76.5947H58.7766V161.566H91.612V76.5947Z",
    fill: "#91A0A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5095 76.5947H50.6741V161.566H83.5095V76.5947Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.344 116.418H83.509V161.566H116.344V116.418Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6823 80.002H59.4866V80.9958H91.6823V80.002Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5806 80.002H50.6741V80.9958H83.5806V80.002Z",
    fill: "#9CADB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6823 87.0298H59.4866V88.0236H91.6823V87.0298Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5806 87.0298H50.6741V88.0236H83.5806V87.0298Z",
    fill: "#9CADB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6823 94.1284H59.4866V95.1222H91.6823V94.1284Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5806 94.1284H50.6741V95.1222H83.5806V94.1284Z",
    fill: "#9CADB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6823 101.156H59.4866V102.15H91.6823V101.156Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5806 101.156H50.6741V102.15H83.5806V101.156Z",
    fill: "#9CADB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6823 108.255H59.4866V109.249H91.6823V108.255Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5806 108.255H50.6741V109.249H83.5806V108.255Z",
    fill: "#9CADB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6823 115.283H59.4866V116.277H91.6823V115.283Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5806 115.283H50.6741V116.277H83.5806V115.283Z",
    fill: "#9CADB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 122.381H59.4866V123.375H128V122.381Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.345 122.381H50.6741V123.375H116.345V122.381Z",
    fill: "#9CADB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 129.409H59.4866V130.403H128V129.409Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.345 129.409H50.6741V130.403H116.345V129.409Z",
    fill: "#9CADB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 136.508H59.4866V137.502H128V136.508Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.345 136.508H50.6741V137.502H116.345V136.508Z",
    fill: "#9CADB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 143.535H59.4866V144.529H128V143.535Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.345 143.535H50.6741V144.529H116.345V143.535Z",
    fill: "#9CADB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 150.634H59.4866V151.628H128V150.634Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.345 150.634H50.6741V151.628H116.345V150.634Z",
    fill: "#9CADB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 157.662H59.4866V158.655H128V157.662Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.345 157.662H50.6741V158.655H116.345V157.662Z",
    fill: "#9CADB7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_539_1250",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 21,
    width: 136,
    height: 140
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M152.52 21.083H17.2698V160.43H152.52V21.083Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_539_1250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.3949 51.8203H35.749V77.0206H49.3949V51.8203Z",
    fill: "#88A3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.486 51.8203H31.8401V77.0206H45.486V51.8203Z",
    fill: "#B3CDE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8624 67.0112H32.7639V92.2115H55.8624V67.0112Z",
    fill: "#88A3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3234 67.0112H26.2249V92.2115H49.3234V67.0112Z",
    fill: "#B3CDE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6247 84.8999H30.9875V161.637H60.6247V84.8999Z",
    fill: "#88A3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1667 84.8999H22.5295V161.637H52.1667V84.8999Z",
    fill: "#B3CDE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3239 54.0918H35.6069V55.0856H49.3239V54.0918Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.557 54.0918H31.8401V55.0856H45.557V54.0918Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3239 56.7183H35.6069V57.7121H49.3239V56.7183Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.557 56.7183H31.8401V57.7121H45.557V56.7183Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3239 59.416H35.6069V60.4098H49.3239V59.416Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.557 59.416H31.8401V60.4098H45.557V59.416Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3239 62.1133H35.6069V63.1071H49.3239V62.1133Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.557 62.1133H31.8401V63.1071H45.557V62.1133Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3239 64.8105H35.6069V65.8044H49.3239V64.8105Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.557 64.8105H31.8401V65.8044H45.557V64.8105Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7909 68.2183H32.5503V69.2121H55.7909V68.2183Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4655 68.2183H26.2249V69.2121H49.4655V68.2183Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7909 71.1284H32.5503V72.1222H55.7909V71.1284Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4655 71.1284H26.2249V72.1222H49.4655V71.1284Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7909 74.0391H32.5503V75.0329H55.7909V74.0391Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4655 74.0391H26.2249V75.0329H49.4655V74.0391Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7909 76.9492H32.5503V77.943H55.7909V76.9492Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4655 76.9492H26.2249V77.943H49.4655V76.9492Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7909 79.8599H32.5503V80.8537H55.7909V79.8599Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4655 79.8599H26.2249V80.8537H49.4655V79.8599Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7909 82.8413H32.5503V83.8351H55.7909V82.8413Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4655 82.8413H26.2249V83.8351H49.4655V82.8413Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4824 87.3135H30.7031V88.3073H60.4824V87.3135Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3799 87.3135H22.6006V88.3073H52.3799V87.3135Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4824 91.7856H30.7031V92.7795H60.4824V91.7856Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3799 91.7856H22.6006V92.7795H52.3799V91.7856Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4824 96.3291H30.7031V97.3229H60.4824V96.3291Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3799 96.3291H22.6006V97.3229H52.3799V96.3291Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4824 100.801H30.7031V101.795H60.4824V100.801Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3799 100.801H22.6006V101.795H52.3799V100.801Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4824 105.344H30.7031V106.338H60.4824V105.344Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3799 105.344H22.6006V106.338H52.3799V105.344Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4824 109.816H30.7031V110.81H60.4824V109.816Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3799 109.816H22.6006V110.81H52.3799V109.816Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4824 114.359H30.7031V115.353H60.4824V114.359Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3799 114.359H22.6006V115.353H52.3799V114.359Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4824 118.832H30.7031V119.825H60.4824V118.832Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3799 118.832H22.6006V119.825H52.3799V118.832Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4824 123.375H30.7031V124.369H60.4824V123.375Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3799 123.375H22.6006V124.369H52.3799V123.375Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4824 127.847H30.7031V128.841H60.4824V127.847Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3799 127.847H22.6006V128.841H52.3799V127.847Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4824 132.319H30.7031V133.313H60.4824V132.319Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3799 132.319H22.6006V133.313H52.3799V132.319Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4824 136.862H30.7031V137.856H60.4824V136.862Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3799 136.862H22.6006V137.856H52.3799V136.862Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4824 141.334H30.7031V142.328H60.4824V141.334Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3799 141.334H22.6006V142.328H52.3799V141.334Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4824 145.878H30.7031V146.872H60.4824V145.878Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3799 145.878H22.6006V146.872H52.3799V145.878Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4824 150.35H30.7031V151.344H60.4824V150.35Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3799 150.35H22.6006V151.344H52.3799V150.35Z",
    fill: "#AEC1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4824 154.893H30.7031V155.887H60.4824V154.893Z",
    fill: "#7A92A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3799 154.893H22.6006V155.887H52.3799V154.893Z",
    fill: "#AEC1CE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_539_1250",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 21,
    width: 136,
    height: 140
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M152.52 21.083H17.2698V160.43H152.52V21.083Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_539_1250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1452 121.529H13.7874V133.313H42.1452V121.529Z",
    fill: "#ACBBBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.841 121.529H74.4827V133.313H102.841V121.529Z",
    fill: "#ACBBBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0026 121.529H70.6448V133.313H99.0026V121.529Z",
    fill: "#BDE3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.315 128.273H14.4983V164.476H122.315V128.273Z",
    fill: "#ACBBBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.816 128.273H-0.000732422V164.476H107.816V128.273Z",
    fill: "#BDE3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7136 134.378H40.9368V138.211H42.7136V134.378Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9685 134.378H47.1917V138.211H48.9685V134.378Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6181 134.378H47.1917V138.211H47.6181V134.378Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2224 134.378H53.4456V138.211H55.2224V134.378Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.872 134.378H53.4456V138.211H53.872V134.378Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4763 134.378H59.6995V138.211H61.4763V134.378Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1259 134.378H59.6995V138.211H60.1259V134.378Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6601 134.378H65.8833V138.211H67.6601V134.378Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3808 134.378H65.9543V138.211H66.3808V134.378Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9147 134.378H72.1379V138.211H73.9147V134.378Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6354 134.378H72.209V138.211H72.6354V134.378Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1687 134.378H78.3918V138.211H80.1687V134.378Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8893 134.378H78.4629V138.211H78.8893V134.378Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4235 134.378H84.6467V138.211H86.4235V134.378Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0732 134.378H84.6467V138.211H85.0732V134.378Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6774 134.378H90.9006V138.211H92.6774V134.378Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3271 134.378H90.9006V138.211H91.3271V134.378Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9313 134.378H97.1545V138.211H98.9313V134.378Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.581 134.378H97.1545V138.211H97.581V134.378Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.186 134.378H103.409V138.211H105.186V134.378Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.836 134.378H103.409V138.211H103.836V134.378Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7136 143.677H40.9368V147.511H42.7136V143.677Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9685 143.677H47.1917V147.511H48.9685V143.677Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6181 143.677H47.1917V147.511H47.6181V143.677Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2224 143.677H53.4456V147.511H55.2224V143.677Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.872 143.677H53.4456V147.511H53.872V143.677Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4763 143.677H59.6995V147.511H61.4763V143.677Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1259 143.677H59.6995V147.511H60.1259V143.677Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6601 143.677H65.8833V147.511H67.6601V143.677Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3808 143.677H65.9543V147.511H66.3808V143.677Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9147 143.677H72.1379V147.511H73.9147V143.677Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6354 143.677H72.209V147.511H72.6354V143.677Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1687 143.677H78.3918V147.511H80.1687V143.677Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8893 143.677H78.4629V147.511H78.8893V143.677Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4235 143.677H84.6467V147.511H86.4235V143.677Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0732 143.677H84.6467V147.511H85.0732V143.677Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6774 143.677H90.9006V147.511H92.6774V143.677Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3271 143.677H90.9006V147.511H91.3271V143.677Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9313 143.677H97.1545V147.511H98.9313V143.677Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.581 143.677H97.1545V147.511H97.581V143.677Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.186 143.677H103.409V147.511H105.186V143.677Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.836 143.677H103.409V147.511H103.836V143.677Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7136 152.905H40.9368V156.739H42.7136V152.905Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9685 152.905H47.1917V156.739H48.9685V152.905Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6181 152.905H47.1917V156.739H47.6181V152.905Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2224 152.905H53.4456V156.739H55.2224V152.905Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.872 152.905H53.4456V156.739H53.872V152.905Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4763 152.905H59.6995V156.739H61.4763V152.905Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1259 152.905H59.6995V156.739H60.1259V152.905Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6601 152.905H65.8833V156.739H67.6601V152.905Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3808 152.905H65.9543V156.739H66.3808V152.905Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9147 152.905H72.1379V156.739H73.9147V152.905Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6354 152.905H72.209V156.739H72.6354V152.905Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1687 152.905H78.3918V156.739H80.1687V152.905Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8893 152.905H78.4629V156.739H78.8893V152.905Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4235 152.905H84.6467V156.739H86.4235V152.905Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0732 152.905H84.6467V156.739H85.0732V152.905Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6774 152.905H90.9006V156.739H92.6774V152.905Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3271 152.905H90.9006V156.739H91.3271V152.905Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9313 152.905H97.1545V156.739H98.9313V152.905Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.581 152.905H97.1545V156.739H97.581V152.905Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.186 152.905H103.409V156.739H105.186V152.905Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.836 152.905H103.409V156.739H103.836V152.905Z",
    fill: "#748281"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_539_1250",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 21,
    width: 136,
    height: 140
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M152.52 21.083H17.2698V160.43H152.52V21.083Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_539_1250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.7241 124.44H73.1331V126.995H97.7241V124.44Z",
    fill: "#D1E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4789 124.44H73.2756V126.995H75.4789V124.44Z",
    fill: "#ACBBBC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_539_1250",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 21,
    width: 136,
    height: 140
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M152.52 21.083H17.2698V160.43H152.52V21.083Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_539_1250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.146 96.897H101.135V137.998H113.146V96.897Z",
    fill: "#B8CBCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.892 96.897H87.7734V137.998H106.892V96.897Z",
    fill: "#D1E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.028 96.897H139.017V166.109H151.028V96.897Z",
    fill: "#B8CBCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.774 96.897H125.655V137.998H144.774V96.897Z",
    fill: "#D1E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.773 118.335H87.7734V167.032H144.773V118.335Z",
    fill: "#D1E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.185 100.73H89.4082V104.564H91.185V100.73Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9057 100.73H89.4792V104.564H89.9057V100.73Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6674 100.73H92.8906V104.564H94.6674V100.73Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3171 100.73H92.8906V104.564H93.3171V100.73Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1499 100.73H96.373V104.564H98.1499V100.73Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7995 100.73H96.373V104.564H96.7995V100.73Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.562 100.73H99.7852V104.564H101.562V100.73Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.283 100.73H99.8562V104.564H100.283V100.73Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.044 100.73H103.268V104.564H105.044V100.73Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.694 100.73H103.268V104.564H103.694V100.73Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.209 100.73H127.432V104.564H129.209V100.73Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.858 100.73H127.432V104.564H127.858V100.73Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.691 100.73H130.914V104.564H132.691V100.73Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.341 100.73H130.914V104.564H131.341V100.73Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.102 100.73H134.325V104.564H136.102V100.73Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.823 100.73H134.396V104.564H134.823V100.73Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.586 100.73H137.809V104.564H139.586V100.73Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.235 100.73H137.809V104.564H138.235V100.73Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.068 100.73H141.291V104.564H143.068V100.73Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.718 100.73H141.291V104.564H141.718V100.73Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.185 109.249H89.4082V113.082H91.185V109.249Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9057 109.249H89.4792V113.082H89.9057V109.249Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6674 109.249H92.8906V113.082H94.6674V109.249Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3171 109.249H92.8906V113.082H93.3171V109.249Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1499 109.249H96.373V113.082H98.1499V109.249Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7995 109.249H96.373V113.082H96.7995V109.249Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.562 109.249H99.7852V113.082H101.562V109.249Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.283 109.249H99.8562V113.082H100.283V109.249Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.044 109.249H103.268V113.082H105.044V109.249Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.694 109.249H103.268V113.082H103.694V109.249Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.209 109.249H127.432V113.082H129.209V109.249Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.858 109.249H127.432V113.082H127.858V109.249Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.691 109.249H130.914V113.082H132.691V109.249Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.341 109.249H130.914V113.082H131.341V109.249Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.102 109.249H134.325V113.082H136.102V109.249Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.823 109.249H134.396V113.082H134.823V109.249Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.586 109.249H137.809V113.082H139.586V109.249Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.235 109.249H137.809V113.082H138.235V109.249Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.068 109.249H141.291V113.082H143.068V109.249Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.718 109.249H141.291V113.082H141.718V109.249Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.185 117.696H89.4082V121.53H91.185V117.696Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9057 117.696H89.4792V121.53H89.9057V117.696Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6674 117.696H92.8906V121.53H94.6674V117.696Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3171 117.696H92.8906V121.53H93.3171V117.696Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1499 117.696H96.373V121.53H98.1499V117.696Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7995 117.696H96.373V121.53H96.7995V117.696Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.562 117.696H99.7852V121.53H101.562V117.696Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.283 117.696H99.8562V121.53H100.283V117.696Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.044 117.696H103.268V121.53H105.044V117.696Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.694 117.696H103.268V121.53H103.694V117.696Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.209 117.696H127.432V121.53H129.209V117.696Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.858 117.696H127.432V121.53H127.858V117.696Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.691 117.696H130.914V121.53H132.691V117.696Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.341 117.696H130.914V121.53H131.341V117.696Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.102 117.696H134.325V121.53H136.102V117.696Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.823 117.696H134.396V121.53H134.823V117.696Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.586 117.696H137.809V121.53H139.586V117.696Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.235 117.696H137.809V121.53H138.235V117.696Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.068 117.696H141.291V121.53H143.068V117.696Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.718 117.696H141.291V121.53H141.718V117.696Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.185 126.214H89.4082V130.048H91.185V126.214Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9057 126.214H89.4792V130.048H89.9057V126.214Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6674 126.214H92.8906V130.048H94.6674V126.214Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3171 126.214H92.8906V130.048H93.3171V126.214Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1499 126.214H96.373V130.048H98.1499V126.214Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7995 126.214H96.373V130.048H96.7995V126.214Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.562 126.214H99.7852V130.048H101.562V126.214Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.283 126.214H99.8562V130.048H100.283V126.214Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.044 126.214H103.268V130.048H105.044V126.214Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.694 126.214H103.268V130.048H103.694V126.214Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.019 120.961H108.242V164.263H110.019V120.961Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.669 120.961H108.242V164.263H108.669V120.961Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.43 120.961H111.653V164.263H113.43V120.961Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.151 120.961H111.724V164.263H112.151V120.961Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.913 120.961H115.136V164.263H116.913V120.961Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.633 120.961H115.207V164.263H115.633V120.961Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.396 120.961H118.619V164.263H120.396V120.961Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.046 120.961H118.619V164.263H119.046V120.961Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.878 120.961H122.102V164.263H123.878V120.961Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.528 120.961H122.102V164.263H122.528V120.961Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.209 126.214H127.432V130.048H129.209V126.214Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.858 126.214H127.432V130.048H127.858V126.214Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.691 126.214H130.914V130.048H132.691V126.214Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.341 126.214H130.914V130.048H131.341V126.214Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.102 126.214H134.325V130.048H136.102V126.214Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.823 126.214H134.396V130.048H134.823V126.214Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.586 126.214H137.809V130.048H139.586V126.214Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.235 126.214H137.809V130.048H138.235V126.214Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.068 126.214H141.291V130.048H143.068V126.214Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.718 126.214H141.291V130.048H141.718V126.214Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.185 134.733H89.4082V138.566H91.185V134.733Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9057 134.733H89.4792V138.566H89.9057V134.733Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6674 134.733H92.8906V138.566H94.6674V134.733Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3171 134.733H92.8906V138.566H93.3171V134.733Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1499 134.733H96.373V138.566H98.1499V134.733Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7995 134.733H96.373V138.566H96.7995V134.733Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.562 134.733H99.7852V138.566H101.562V134.733Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.283 134.733H99.8562V138.566H100.283V134.733Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.044 134.733H103.268V138.566H105.044V134.733Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.694 134.733H103.268V138.566H103.694V134.733Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.209 134.733H127.432V138.566H129.209V134.733Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.858 134.733H127.432V138.566H127.858V134.733Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.691 134.733H130.914V138.566H132.691V134.733Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.341 134.733H130.914V138.566H131.341V134.733Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.102 134.733H134.325V138.566H136.102V134.733Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.823 134.733H134.396V138.566H134.823V134.733Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.586 134.733H137.809V138.566H139.586V134.733Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.235 134.733H137.809V138.566H138.235V134.733Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.068 134.733H141.291V138.566H143.068V134.733Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.718 134.733H141.291V138.566H141.718V134.733Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.185 143.251H89.4082V147.085H91.185V143.251Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9057 143.251H89.4792V147.085H89.9057V143.251Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6674 143.251H92.8906V147.085H94.6674V143.251Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3171 143.251H92.8906V147.085H93.3171V143.251Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1499 143.251H96.373V147.085H98.1499V143.251Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7995 143.251H96.373V147.085H96.7995V143.251Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.562 143.251H99.7852V147.085H101.562V143.251Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.283 143.251H99.8562V147.085H100.283V143.251Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.044 143.251H103.268V147.085H105.044V143.251Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.694 143.251H103.268V147.085H103.694V143.251Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.209 143.251H127.432V147.085H129.209V143.251Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.858 143.251H127.432V147.085H127.858V143.251Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.691 143.251H130.914V147.085H132.691V143.251Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.341 143.251H130.914V147.085H131.341V143.251Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.102 143.251H134.325V147.085H136.102V143.251Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.823 143.251H134.396V147.085H134.823V143.251Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.586 143.251H137.809V147.085H139.586V143.251Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.235 143.251H137.809V147.085H138.235V143.251Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.068 143.251H141.291V147.085H143.068V143.251Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.718 143.251H141.291V147.085H141.718V143.251Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.185 151.77H89.4082V155.603H91.185V151.77Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9057 151.77H89.4792V155.603H89.9057V151.77Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6674 151.77H92.8906V155.603H94.6674V151.77Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3171 151.77H92.8906V155.603H93.3171V151.77Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1499 151.77H96.373V155.603H98.1499V151.77Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7995 151.77H96.373V155.603H96.7995V151.77Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.562 151.77H99.7852V155.603H101.562V151.77Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.283 151.77H99.8562V155.603H100.283V151.77Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.044 151.77H103.268V155.603H105.044V151.77Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.694 151.77H103.268V155.603H103.694V151.77Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.209 151.77H127.432V155.603H129.209V151.77Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.858 151.77H127.432V155.603H127.858V151.77Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.691 151.77H130.914V155.603H132.691V151.77Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.341 151.77H130.914V155.603H131.341V151.77Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.102 151.77H134.325V155.603H136.102V151.77Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.823 151.77H134.396V155.603H134.823V151.77Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.586 151.77H137.809V155.603H139.586V151.77Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.235 151.77H137.809V155.603H138.235V151.77Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.068 151.77H141.291V155.603H143.068V151.77Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.718 151.77H141.291V155.603H141.718V151.77Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.185 160.288H89.4082V164.121H91.185V160.288Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9057 160.288H89.4792V164.121H89.9057V160.288Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6674 160.288H92.8906V164.121H94.6674V160.288Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3171 160.288H92.8906V164.121H93.3171V160.288Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1499 160.288H96.373V164.121H98.1499V160.288Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7995 160.288H96.373V164.121H96.7995V160.288Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.562 160.288H99.7852V164.121H101.562V160.288Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.283 160.288H99.8562V164.121H100.283V160.288Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.044 160.288H103.268V164.121H105.044V160.288Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.694 160.288H103.268V164.121H103.694V160.288Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.209 160.288H127.432V164.121H129.209V160.288Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.858 160.288H127.432V164.121H127.858V160.288Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.691 160.288H130.914V164.121H132.691V160.288Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.341 160.288H130.914V164.121H131.341V160.288Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.102 160.288H134.325V164.121H136.102V160.288Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.823 160.288H134.396V164.121H134.823V160.288Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.586 160.288H137.809V164.121H139.586V160.288Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.235 160.288H137.809V164.121H138.235V160.288Z",
    fill: "#748281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.068 160.288H141.291V164.121H143.068V160.288Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.718 160.288H141.291V164.121H141.718V160.288Z",
    fill: "#748281"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0428 158.939H19.1887L43.7087 24.1353H58.4917L34.0428 158.939Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.6007 158.939H64.8176L89.2665 24.1353H104.05L79.6007 158.939Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.305 158.939H109.522L133.971 24.1353H148.754L124.305 158.939Z",
    fill: "white"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M105.115 43.9407C104.547 43.0179 102.628 42.379 100.353 42.379C99.8559 42.379 99.4294 42.45 98.9319 42.45C98.5055 41.2432 96.8708 40.3204 94.8097 40.3204C94.1701 40.3204 93.5304 40.3914 93.0329 40.6044C92.3222 38.8297 89.7636 37.4809 86.7075 37.4809C85.4282 37.4809 84.291 37.6939 83.296 38.1198C82.4432 35.4933 80.0267 33.5767 77.1838 33.5767C74.1277 33.5767 71.6402 35.6353 70.9294 38.4748C70.4319 38.2618 69.8634 38.1198 69.2948 38.1198C67.4469 38.1198 65.8833 39.3266 65.3147 40.9593C64.2486 40.5334 62.8272 40.2494 61.3347 40.2494C58.4918 40.2494 56.1464 41.1013 55.2225 42.308C52.5928 42.45 50.4606 43.0889 50.0342 43.7988H105.115V43.9407Z",
    fill: "#DDEBED"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2536 163.625H13.5029V19.7344H63.2536V163.625ZM18.0516 159.082H58.776V24.2775H18.0516V159.082Z",
    fill: "#EFEFEF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M108.029 163.625H58.2786V19.7344H108.029V163.625ZM62.7561 159.082H103.481V24.2775H62.7561V159.082Z",
    fill: "#EFEFEF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M153.302 163.625H103.48V19.7344H153.302V163.625ZM108.029 159.082H148.754V24.2775H108.029V159.082Z",
    fill: "#EFEFEF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9492 24.4194H63.1113V159.223H66.9492V24.4194Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M111.725 24.1357H107.887V158.94H111.725V24.1357Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M157.14 19.5923H153.302V163.554H157.14V19.5923Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_539_1250",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 22,
    width: 235,
    height: 235
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M275.902 139.276C275.902 203.803 223.522 256.191 158.846 256.191C94.2414 256.191 41.79 203.874 41.79 139.276C41.79 74.7491 94.1703 22.3608 158.846 22.3608C223.522 22.3608 275.902 74.6781 275.902 139.276Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_539_1250)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.953 181.087C248.184 181.087 268.653 182.791 268.653 184.921C268.653 187.05 248.184 188.754 222.953 188.754C197.723 188.754 177.254 187.05 177.254 184.921C177.254 182.791 197.723 181.087 222.953 181.087Z",
    fill: "#2E3435"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.25 181.229H193.601V144.671H192.25V181.229Z",
    fill: "#767373"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.388 181.229H195.165V144.671H193.388V181.229Z",
    fill: "#C1C1BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.787 182.862C184.787 183.926 185.64 184.849 186.777 184.849C187.843 184.849 188.767 183.997 188.767 182.862C188.767 181.797 187.914 180.874 186.777 180.874C185.711 180.945 184.787 181.797 184.787 182.862Z",
    fill: "#433F3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.427 182.862C185.427 183.926 186.28 184.849 187.417 184.849C188.483 184.849 189.407 183.997 189.407 182.862C189.407 181.797 188.554 180.874 187.417 180.874C186.351 180.945 185.427 181.797 185.427 182.862Z",
    fill: "#767373"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.291 182.862C198.291 183.926 199.144 184.849 200.281 184.849C201.347 184.849 202.271 183.997 202.271 182.862C202.271 181.797 201.418 180.874 200.281 180.874C199.215 180.945 198.291 181.797 198.291 182.862Z",
    fill: "#433F3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.931 182.862C198.931 183.926 199.784 184.849 200.921 184.849C201.987 184.849 202.911 183.997 202.911 182.862C202.911 181.797 202.058 180.874 200.921 180.874C199.784 180.945 198.931 181.797 198.931 182.862Z",
    fill: "#767373"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.153 181.584H202.769V179.525H183.153V181.584Z",
    fill: "#433F3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.219 181.584H204.119V179.525H184.219V181.584Z",
    fill: "#918C8C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.667 181.229H253.017V144.671H251.667V181.229Z",
    fill: "#767373"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.732 181.229H254.509V144.671H252.732V181.229Z",
    fill: "#C1C1BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.204 182.862C244.204 183.926 245.057 184.849 246.194 184.849C247.26 184.849 248.184 183.997 248.184 182.862C248.184 181.797 247.331 180.874 246.194 180.874C245.057 180.945 244.204 181.797 244.204 182.862Z",
    fill: "#433F3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.844 182.862C244.844 183.926 245.697 184.849 246.834 184.849C247.9 184.849 248.824 183.997 248.824 182.862C248.824 181.797 247.971 180.874 246.834 180.874C245.697 180.874 244.844 181.797 244.844 182.862Z",
    fill: "#767373"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.708 182.862C257.708 183.926 258.561 184.849 259.698 184.849C260.764 184.849 261.688 183.997 261.688 182.862C261.688 181.797 260.835 180.874 259.698 180.874C258.561 180.945 257.708 181.797 257.708 182.862Z",
    fill: "#433F3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.347 182.862C258.347 183.926 259.2 184.849 260.337 184.849C261.404 184.849 262.327 183.997 262.327 182.862C262.327 181.797 261.475 180.874 260.337 180.874C259.2 180.945 258.347 181.797 258.347 182.862Z",
    fill: "#767373"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.569 181.584H262.114V179.525H242.569V181.584Z",
    fill: "#433F3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.636 181.584H263.536V179.525H243.636V181.584Z",
    fill: "#918C8C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.335 70.1348H270.927V148.859H175.335V70.1348Z",
    fill: "#CBDBE3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.928 70.1348H276.045V148.859H270.928V70.1348Z",
    fill: "#E4E9EC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.164 162.985H251.667V164.476H195.164V162.985Z",
    fill: "#C1C1BF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_539_1250",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 22,
    width: 235,
    height: 235
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M275.902 139.276C275.902 203.803 223.522 256.191 158.846 256.191C94.2414 256.191 41.79 203.874 41.79 139.276C41.79 74.7491 94.1703 22.3608 158.846 22.3608C223.522 22.3608 275.902 74.6781 275.902 139.276Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_539_1250)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.883 221.905C156.288 221.905 194.738 224.318 194.738 227.3C194.738 230.281 156.288 232.695 108.883 232.695C61.4775 232.695 23.0273 230.281 23.0273 227.3C23.0273 224.318 61.4775 221.905 108.883 221.905Z",
    fill: "#2E3435"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.242 221.905C231.411 221.905 250.174 224.318 250.174 227.3C250.174 230.281 231.411 232.695 208.242 232.695C185.072 232.695 166.309 230.281 166.309 227.3C166.38 224.318 185.143 221.905 208.242 221.905Z",
    fill: "#2E3435"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.876 218.568H97.7239V119.258H95.876V218.568Z",
    fill: "#767373"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.3682 218.568H99.9268V119.258H97.3682V218.568Z",
    fill: "#C1C1BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7119 172.427H124.519V169.02H71.7119V172.427Z",
    fill: "#331411"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7119 172.072C71.7119 175.124 83.5099 177.538 98.0797 177.538C112.65 177.538 124.448 175.124 124.448 172.072C124.448 169.02 112.65 166.606 98.0797 166.606C83.5099 166.606 71.7119 169.02 71.7119 172.072Z",
    fill: "#331411"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7119 169.02C71.7119 172.072 83.5099 174.486 98.0797 174.486C112.65 174.486 124.448 172.072 124.448 169.02C124.448 165.967 112.65 163.554 98.0797 163.554C83.5099 163.554 71.7119 165.967 71.7119 169.02Z",
    fill: "#551911"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.2864 220.272C85.2864 221.834 86.5657 223.041 88.0582 223.041C89.6218 223.041 90.83 221.834 90.83 220.272C90.83 218.711 89.5507 217.504 88.0582 217.504C86.4946 217.504 85.2864 218.711 85.2864 220.272Z",
    fill: "#433F3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.21 220.272C86.21 221.834 87.4893 223.041 88.9818 223.041C90.5454 223.041 91.7536 221.834 91.7536 220.272C91.7536 218.711 90.4743 217.504 88.9818 217.504C87.4182 217.504 86.21 218.711 86.21 220.272Z",
    fill: "#767373"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.404 220.272C104.404 221.834 105.613 223.041 107.176 223.041C108.74 223.041 109.948 221.834 109.948 220.272C109.948 218.711 108.74 217.504 107.176 217.504C105.613 217.504 104.404 218.711 104.404 220.272Z",
    fill: "#433F3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.258 220.272C105.258 221.834 106.466 223.041 108.029 223.041C109.593 223.041 110.801 221.834 110.801 220.272C110.801 218.711 109.522 217.504 108.029 217.504C106.537 217.504 105.258 218.711 105.258 220.272Z",
    fill: "#767373"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.9404 218.356H110.659V215.516H82.9404V218.356Z",
    fill: "#433F3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5049 218.356H112.65V215.516H84.5049V218.356Z",
    fill: "#918C8C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5889 115.425C67.5889 121.317 77.6811 126.144 90.0477 126.144C102.485 126.144 112.507 121.387 112.507 115.425C112.507 109.533 102.983 108.61 90.5452 108.61C78.1786 108.61 67.5889 109.462 67.5889 115.425Z",
    fill: "#331411"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0007 115.425C71.0007 121.317 81.093 126.144 93.4596 126.144C105.897 126.144 115.918 121.387 115.918 115.425C115.918 109.533 106.395 108.61 93.9571 108.61C81.5905 108.61 71.0007 109.462 71.0007 115.425Z",
    fill: "#551911"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.365 223.396H228.213V171.575H226.365V223.396Z",
    fill: "#767373"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.857 223.396H230.345V171.575H227.857V223.396Z",
    fill: "#C1C1BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.817 172.64H237.736V130.403H235.817V172.64Z",
    fill: "#767373"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.31 172.64H239.868V130.403H237.31V172.64Z",
    fill: "#C1C1BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.2 177.893H254.936V174.486H202.2V177.893Z",
    fill: "#331411"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.2 177.538C202.2 180.591 213.998 183.004 228.568 183.004C243.138 183.004 254.936 180.591 254.936 177.538C254.936 174.486 243.138 172.072 228.568 172.072C213.998 172.072 202.2 174.486 202.2 177.538Z",
    fill: "#331411"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.2 174.486C202.2 177.538 213.998 179.951 228.568 179.951C243.138 179.951 254.936 177.538 254.936 174.486C254.936 171.504 243.138 169.02 228.568 169.02C213.998 169.02 202.2 171.433 202.2 174.486Z",
    fill: "#551911"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.775 225.738C215.775 227.3 216.984 228.507 218.547 228.507C220.111 228.507 221.319 227.229 221.319 225.738C221.319 224.176 220.111 222.97 218.547 222.97C216.984 222.97 215.775 224.176 215.775 225.738Z",
    fill: "#433F3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.628 225.738C216.628 227.3 217.907 228.507 219.4 228.507C220.963 228.507 222.172 227.229 222.172 225.738C222.172 224.176 220.963 222.97 219.4 222.97C217.907 222.97 216.628 224.176 216.628 225.738Z",
    fill: "#767373"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.823 225.738C234.823 227.3 236.102 228.507 237.594 228.507C239.158 228.507 240.366 227.229 240.366 225.738C240.366 224.176 239.158 222.97 237.594 222.97C236.102 222.97 234.823 224.176 234.823 225.738Z",
    fill: "#433F3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.746 225.738C235.746 227.3 236.954 228.507 238.518 228.507C240.082 228.507 241.29 227.229 241.29 225.738C241.29 224.176 240.01 222.97 238.518 222.97C237.025 222.97 235.746 224.176 235.746 225.738Z",
    fill: "#767373"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.43 223.821H241.148V220.982H213.43V223.821Z",
    fill: "#433F3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.922 223.821H243.138V220.982H214.922V223.821Z",
    fill: "#918C8C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.627 134.662C259.627 140.554 249.534 145.381 237.168 145.381C224.73 145.381 214.709 140.625 214.709 134.662C214.709 128.77 224.233 127.847 236.67 127.847C248.966 127.847 259.627 128.77 259.627 134.662Z",
    fill: "#551911"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.216 134.662C256.216 140.554 246.123 145.381 233.757 145.381C221.319 145.381 211.298 140.625 211.298 134.662C211.298 128.77 220.822 127.847 233.259 127.847C245.555 127.847 256.216 128.77 256.216 134.662Z",
    fill: "#331411"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.991 152.764C132.549 154.893 132.834 155.248 133.047 155.603C133.26 155.958 131.768 155.745 131.483 155.674C131.199 155.603 129.493 154.042 128.498 153.687C127.859 153.403 130.204 154.822 131.057 155.674C131.341 155.958 129.351 155.674 129.351 155.674L126.437 154.042C126.437 154.042 129.138 155.745 128.427 155.745C127.716 155.745 127.503 155.745 127.503 155.745C127.503 155.745 126.437 155.461 125.655 155.035C125.3 154.822 124.376 155.106 123.594 155.035C121.178 154.609 121.036 154.042 121.036 154.042L119.614 152.338L124.305 151.06C124.447 150.989 128.783 151.77 129.991 152.764Z",
    fill: "#F9BCAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.28 155.674H132.407V135.656H129.28V155.674Z",
    fill: "#A9AAAB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.991 155.674H133.758V135.656H129.991V155.674Z",
    fill: "#CDCCCB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.703 227.655H175.762V161.921H144.703V227.655Z",
    fill: "#7C7B7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.117 153.828L125.371 150.492C125.371 150.492 118.69 146.02 114.639 138.708C110.588 131.397 111.725 121.104 111.796 120.962C112.081 120.678 105.755 124.582 105.755 124.582C105.755 124.582 104.618 136.295 108.314 142.896C111.796 149.143 118.193 153.19 119.117 153.828Z",
    fill: "#0F1717"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.036 152.764L125.3 150.492C125.3 150.492 118.62 146.02 114.568 138.708C110.944 132.106 111.441 123.162 111.726 121.316C110.02 122.381 107.888 123.659 107.888 123.659C107.888 123.659 106.751 135.372 110.446 141.974C113.716 147.936 119.686 151.841 121.036 152.764Z",
    fill: "#232E30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.092 213.6L123.452 218.214C123.452 218.214 119.046 218.498 118.904 218.001C118.832 217.504 119.756 213.032 119.756 213.032L124.092 213.6Z",
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.743 222.828C139.443 225.028 138.235 227.158 138.235 227.158C138.235 227.158 134.681 228.152 131.27 228.081C127.148 228.01 122.315 225.667 122.315 225.667L122.457 226.874H116.913C116.913 226.874 115.705 224.318 116.487 221.479C117.269 218.639 118.548 217.22 118.548 217.22C118.548 217.22 122.599 217.859 123.452 217.646C124.305 217.433 127.645 220.769 129.351 221.479C130.986 222.26 135.037 221.408 136.743 222.828Z",
    fill: "#2A2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.818 227.726C134.539 227.939 132.904 228.152 131.27 228.152C127.148 228.081 122.315 225.738 122.315 225.738L122.457 226.945H120.111C119.827 226.803 119.685 226.732 119.685 226.732V226.945H116.842C116.842 226.945 115.634 224.389 116.416 221.55C116.771 220.272 117.269 219.278 117.624 218.568C118.832 218.71 120.325 218.852 120.751 218.781C121.604 218.568 124.944 221.905 126.65 222.615C128.356 223.324 132.336 222.473 134.113 223.892C136.032 225.383 136.032 226.945 135.818 227.726Z",
    fill: "#0B0E10"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.684 212.18L104.405 216.652C104.405 216.652 99.9983 216.297 99.9983 215.8C99.9983 215.303 101.562 211.044 101.562 211.044L105.684 212.18Z",
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.843 223.182C119.188 225.738 117.696 227.725 117.696 227.725C117.696 227.725 114 228.151 110.659 227.655C106.537 227.016 102.131 223.963 102.131 223.963L102.06 225.17L96.5872 224.389C96.5872 224.389 95.7343 221.621 96.9425 218.994C98.1508 216.368 99.6433 215.09 99.6433 215.09C99.6433 215.09 103.552 216.297 104.405 216.226C105.258 216.155 108.101 219.917 109.664 220.911C111.228 221.763 115.35 221.55 116.843 223.182Z",
    fill: "#2A2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.639 227.868C113.431 227.868 112.009 227.797 110.659 227.584C106.537 226.945 102.13 223.893 102.13 223.893L102.059 225.099L99.5007 224.744C99.0742 224.46 98.7899 224.248 98.7899 224.248L98.7189 224.673L96.5156 224.319C96.5156 224.319 95.6628 221.55 96.871 218.924C97.5106 217.504 98.2214 216.51 98.7899 215.871C99.9271 216.297 101.277 216.794 101.775 216.723C102.699 216.723 105.115 220.769 106.608 221.834C108.1 222.899 112.152 223.041 113.573 224.815C114.568 226.022 114.781 227.087 114.639 227.868Z",
    fill: "#0B0E10"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.319 119.258C107.319 119.258 118.477 129.551 118.762 129.551C119.046 129.551 117.909 138.779 116.559 138.424C112.365 137.359 106.751 132.603 104.405 129.409C102.06 126.215 107.319 119.258 107.319 119.258Z",
    fill: "#232E30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.169 119.897C80.169 119.897 83.5094 127.705 84.1491 131.539C84.7887 135.372 84.2201 159.863 84.2201 159.863C84.2201 159.863 93.8149 158.798 100.993 158.443C108.172 158.088 111.867 156.1 111.867 156.1C111.867 156.1 106.253 125.576 106.253 125.434C106.253 125.221 107.603 119.684 107.603 119.684C107.603 119.684 104.831 115.141 94.7388 114.999C84.5044 114.928 79.9558 119.684 80.169 119.897Z",
    fill: "#232E30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.7143 115.567L97.6532 136.934L87.7031 115.851C87.7031 115.851 91.1146 114.502 94.0286 114.644C95.3789 114.786 96.0897 114.644 99.7143 115.567Z",
    fill: "#D4D2D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.6529 136.933L98.2215 132.035L96.5868 123.588C96.5868 123.588 96.3736 124.085 95.1654 124.085C93.9572 124.085 93.6018 123.659 93.6018 123.659L94.1704 129.764L97.6529 136.933Z",
    fill: "#EE3E3B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.654 160.572C111.654 160.572 124.021 166.038 130.204 180.449C133.403 192.091 125.727 216.51 125.727 216.51L115.35 215.658C115.35 215.658 124.59 193.297 120.681 183.146C117.838 175.764 110.304 171.22 106.893 169.517C106.111 169.091 102.202 168.949 102.628 169.233C105.684 171.22 110.304 177.325 111.868 182.223C114.142 189.18 108.669 213.671 107.603 215.019C107.177 215.516 97.7243 214.38 97.7243 214.38C97.7243 214.38 104.76 187.831 101.847 183.643C94.8814 173.634 83.652 173.492 83.3677 167.174C83.0834 161.708 83.5098 162.205 85.642 161.566C90.7592 159.863 111.654 160.572 111.654 160.572Z",
    fill: "#0F1717"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.3989 118.264C91.5411 119.613 93.1046 120.535 94.8104 120.322C96.5161 120.11 97.7954 118.832 97.6533 117.483L97.1558 113.65C97.0136 112.301 95.45 111.378 93.7443 111.591C92.0386 111.804 90.7593 113.082 90.9014 114.431L91.3989 118.264Z",
    fill: "#EE9C94"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.2979 120.82L94.7393 120.323L92.1807 120.607L93.6021 123.73L94.0285 124.156C94.5971 124.724 95.5921 124.724 96.1607 124.085L96.5161 123.659L97.2979 120.82Z",
    fill: "#D42027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.8101 120.323C94.8101 120.323 91.5407 124.156 91.4697 125.079C91.3275 126.002 87.845 115.851 87.845 115.851C87.845 115.851 90.9011 114.431 90.9722 114.644C92.3225 118.193 94.8101 120.323 94.8101 120.323Z",
    fill: "#F3E8E7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.7393 120.323C94.7393 120.323 98.5061 122.736 98.7904 123.588C99.0747 124.511 99.0747 115.283 99.0747 115.283C99.0747 115.283 97.2979 114.644 97.2979 114.857C97.2979 116.774 94.7393 120.323 94.7393 120.323Z",
    fill: "#F3E8E7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.2976 136.295L84.931 120.465L87.916 119.826C87.916 119.826 85.5706 119.187 82.7988 117.98C84.5046 116.916 88.6268 115.425 88.6268 115.425L97.2976 136.295Z",
    fill: "#2B3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.6533 136.934L103.694 119.968L100.709 119.4L104.405 117.554L99.2169 115.425L97.6533 136.934Z",
    fill: "#2B3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.8711 141.051C96.8711 141.548 97.2265 141.903 97.724 141.903C98.2215 141.903 98.5768 141.548 98.5768 141.051C98.5768 140.554 98.2215 140.199 97.724 140.199C97.2975 140.199 96.8711 140.554 96.8711 141.051Z",
    fill: "#A29899"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.5107 145.665C97.5107 146.162 97.8661 146.517 98.3636 146.517C98.8611 146.517 99.2165 146.162 99.2165 145.665C99.2165 145.168 98.8611 144.813 98.3636 144.813C97.8661 144.813 97.5107 145.168 97.5107 145.665Z",
    fill: "#A29899"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9375 150.492C97.9375 150.989 98.2929 151.344 98.7904 151.344C99.2879 151.344 99.6432 150.989 99.6432 150.492C99.6432 149.995 99.2879 149.64 98.7904 149.64C98.2929 149.64 97.9375 149.995 97.9375 150.492Z",
    fill: "#A29899"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.5059 154.893C98.5059 155.39 98.8612 155.745 99.3587 155.745C99.8562 155.745 100.212 155.39 100.212 154.893C100.212 154.396 99.8562 154.042 99.3587 154.042C98.8612 154.042 98.5059 154.396 98.5059 154.893Z",
    fill: "#A29899"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.8289 101.298C76.6157 102.86 77.6818 104.35 79.1743 104.563C80.7379 104.776 83.5097 104.279 83.794 102.718C84.0072 101.156 81.5908 99.0974 80.0272 98.8845C78.5347 98.6005 77.0421 99.7363 76.8289 101.298Z",
    fill: "#F6A399"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.951 101.156C81.4485 108.255 87.2764 115.07 94.5969 115.07C101.917 115.07 107.461 108.255 107.461 101.156C107.461 94.0576 105.897 86.604 98.5769 86.604C91.2565 86.533 79.8849 84.8293 80.951 101.156Z",
    fill: "#F9BCAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.4334 87.4561C83.0831 89.6566 83.4384 94.4838 83.7938 99.1689C84.2913 106.268 89.5506 113.65 96.8711 113.366C99.8561 113.224 102.699 111.592 104.049 110.598C101.704 113.366 98.4347 115.283 94.6679 115.283C87.3474 115.283 81.4484 108.468 81.022 101.369C80.3112 91.8572 79.8137 88.6628 84.4334 87.4561Z",
    fill: "#F6A399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0527 99.6658C88.9817 99.6658 88.9106 99.6658 88.9106 99.6658C88.6263 99.5948 88.4841 99.2399 88.5552 98.9559C89.1949 97.1103 91.1849 96.1164 92.9617 96.7553C93.246 96.8263 93.3881 97.1812 93.3171 97.4652C93.246 97.7491 92.8906 97.8911 92.6063 97.8201C91.327 97.3942 89.9767 98.1041 89.5502 99.3818C89.4792 99.5238 89.2659 99.6658 89.0527 99.6658ZM104.973 99.2399C104.76 99.2399 104.618 99.1689 104.475 98.9559C103.836 97.7491 102.343 97.3232 101.206 97.9621C100.922 98.1041 100.638 98.0331 100.495 97.7491C100.353 97.4652 100.424 97.1812 100.709 97.0393C102.414 96.1164 104.546 96.7553 105.47 98.459C105.613 98.743 105.542 99.0269 105.257 99.1689C105.115 99.2399 105.044 99.2399 104.973 99.2399Z",
    fill: "#331410"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3731 111.236C95.0228 111.236 93.6013 110.739 92.5352 109.817C92.322 109.604 92.322 109.249 92.4642 109.036C92.6774 108.823 93.0327 108.823 93.246 108.965C95.236 110.668 98.221 110.526 99.9268 108.539C100.14 108.326 100.495 108.326 100.709 108.468C100.922 108.681 100.922 109.036 100.78 109.249C99.5714 110.526 97.9367 111.236 96.3731 111.236ZM79.6001 103.854C78.8183 103.854 78.0365 103.357 77.7522 102.576C77.3968 101.582 77.8943 100.517 78.8893 100.162C79.1736 100.091 79.4579 100.162 79.6001 100.446C79.7422 100.73 79.6001 101.014 79.3158 101.156C78.8893 101.298 78.6761 101.795 78.8183 102.221C78.9604 102.647 79.3869 102.86 79.8844 102.789C80.1686 102.718 80.4529 102.86 80.524 103.144C80.5951 103.428 80.4529 103.712 80.1686 103.783C79.9554 103.854 79.7422 103.854 79.6001 103.854Z",
    fill: "#ED7660"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.993 101.156C100.993 102.079 101.491 102.86 102.059 102.86C102.628 102.86 103.125 102.079 103.125 101.156C103.125 100.233 102.628 99.4526 102.059 99.4526C101.491 99.5236 100.993 100.233 100.993 101.156Z",
    fill: "#3B150E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.988 100.305C101.988 100.588 102.13 100.801 102.344 100.801C102.557 100.801 102.699 100.588 102.699 100.305C102.699 100.021 102.557 99.8076 102.344 99.8076C102.13 99.8076 101.988 100.092 101.988 100.305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.332 101.227C90.332 102.15 90.8295 102.931 91.3981 102.931C91.9667 102.931 92.4642 102.15 92.4642 101.227C92.4642 100.304 91.9667 99.5234 91.3981 99.5234C90.7585 99.5944 90.332 100.304 90.332 101.227Z",
    fill: "#3B150E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.3271 100.517C91.3271 100.801 91.4693 101.014 91.6825 101.014C91.8957 101.014 92.0379 100.801 92.0379 100.517C92.0379 100.233 91.8957 100.021 91.6825 100.021C91.4693 100.021 91.3271 100.233 91.3271 100.517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0129 105.841C96.5154 105.841 96.089 105.699 95.7336 105.345C95.5204 105.132 95.5204 104.777 95.6625 104.564C95.8758 104.351 96.2311 104.351 96.4443 104.564C96.6576 104.706 96.8708 104.848 97.1551 104.777C97.5815 104.706 97.9369 104.28 97.8658 103.854C97.8658 103.57 98.079 103.286 98.3633 103.286C98.6476 103.215 98.9319 103.499 98.9319 103.783C99.0029 104.777 98.2922 105.699 97.2972 105.841C97.2261 105.841 97.1551 105.841 97.0129 105.841Z",
    fill: "#ED7660"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.61 87.4558C78.1075 84.9713 80.3108 83.2676 82.8694 83.3386C83.509 83.3386 84.2198 83.3386 85.0015 83.2676C85.1437 83.2676 85.2148 83.2676 85.3569 83.2676C85.7123 83.1966 88.6973 80.925 91.327 79.9312C91.8956 79.7183 91.9666 81.209 92.6063 80.925C95.0938 79.8602 97.3681 78.0856 98.0078 78.0146C99.3582 77.8016 99.7135 81.138 100.424 80.925C101.206 80.6411 105.47 77.0208 106.039 76.8078C107.034 76.4529 107.176 80.0732 107.105 84.0485C107.105 84.4744 108.1 84.8293 108.1 85.2552C107.958 89.8694 106.821 95.1224 106.821 95.1224C106.821 95.1224 105.47 88.2367 100.566 89.3015C98.221 89.7984 95.307 91.5731 91.6113 90.7212C89.6923 90.2953 87.418 89.6564 86.0676 89.7984C84.2908 89.9404 82.8694 91.1471 82.3008 92.7798C82.1587 93.1348 82.0876 93.5607 82.0165 93.9866C81.8744 96.1872 82.8694 99.2396 82.9405 100.872C83.0115 101.582 81.8033 102.221 81.8033 102.221C81.1636 102.576 80.8794 100.375 80.0265 99.5946C79.1025 98.7427 78.6761 99.0977 78.6761 99.0977C78.6761 99.0977 77.1836 96.0452 77.1836 91.4311C77.1836 90.0113 77.3968 88.6626 77.61 87.4558Z",
    fill: "#2F1210"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.6292 228.081V161.211H56.2178V228.081H59.6292Z",
    fill: "#7C7B7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1214 228.081V161.211H57.71V228.081H61.1214Z",
    fill: "#A8A4A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.404 147.085H156.856V114.999H104.404V147.085Z",
    fill: "#BFBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.253 147.085H158.633V114.999H106.253V147.085Z",
    fill: "#DDE1DF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.092 143.251H137.524V129.835H124.092V143.251Z",
    fill: "#ADAEAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.514 143.251H138.946V129.835H125.514V143.251Z",
    fill: "#C4C5C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.147 156.526H147.546V154.68H113.147V156.526Z",
    fill: "#A9AAAB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.568 156.526H148.896V154.68H114.568V156.526Z",
    fill: "#CDCCCB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.353 153.332C103.196 155.035 103.338 155.177 104.333 156.313C104.76 156.81 103.338 156.455 103.054 156.384C102.77 156.313 99.9979 154.68 99.0029 154.396C98.2921 154.183 101.064 155.319 102.13 156.384C102.414 156.668 100.709 156.384 100.709 156.384L97.0128 154.964C97.0128 154.964 100.638 156.455 99.8557 156.526C99.145 156.597 98.15 156.455 98.15 156.455C98.15 156.455 97.2971 156.313 96.3732 156.171C95.8046 156.1 95.5914 156.455 94.1699 156.384C91.327 156.171 91.256 155.248 91.256 155.248L89.6924 153.402L92.5353 151.486C92.6063 151.486 98.5054 152.267 100.353 153.332Z",
    fill: "#F9BCAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5083 139.915C68.3 147.581 83.1541 154.538 89.3374 156.455C90.5457 154.254 92.0382 153.118 94.2414 151.699C80.7377 146.801 79.2452 142.896 78.8187 141.051C78.4634 136.791 80.8088 133.668 83.7938 130.261C82.8699 126.498 80.5245 120.819 80.1691 120.039C78.2502 122.381 70.7165 131.964 69.5083 139.915Z",
    fill: "#0F1717"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.4696 153.544L95.0943 151.202C95.0943 151.202 79.8137 146.091 78.8187 141.122C78.7476 140.128 78.8187 139.134 78.9609 138.211C76.6865 134.591 81.022 130.545 84.5756 126.64C83.2252 124.014 80.5955 119.471 80.5955 119.471C80.5955 119.471 71.4983 130.119 69.6504 139.063C70.7875 147.369 86.6367 152.267 91.4696 153.544Z",
    fill: "#232E30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1279 162.347H155.79V156.526H17.1279V162.347Z",
    fill: "#7C7B7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2988 162.347H198.149V156.526H54.2988V162.347Z",
    fill: "#A8A4A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.852 227.655H192.605V161.921H171.852V227.655Z",
    fill: "#A8A4A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.287 156.526H185.356V149.64H156.287V156.526Z",
    fill: "#D6D4D3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.553 156.526H193.245V149.64H174.553V156.526Z",
    fill: "#F1F2F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.245 156.171H156.287V156.1H193.245V156.171ZM193.245 155.887H156.287V155.816H193.245V155.887ZM193.245 155.603H156.287V155.532H193.245V155.603ZM193.245 155.319H156.287V155.248H193.245V155.319ZM193.245 155.035H156.287V154.893H193.245V155.035ZM193.245 154.751H156.287V154.68H193.245V154.751ZM193.245 154.467H156.287V154.396H193.245V154.467ZM193.245 154.184H156.287V154.042H193.245V154.184ZM193.245 153.829H156.287V153.758H193.245V153.829ZM193.245 153.545H156.287V153.474H193.245V153.545ZM193.245 153.261H156.287V153.19H193.245V153.261ZM193.245 152.977H156.287V152.835H193.245V152.977ZM193.245 152.693H156.287V152.622H193.245V152.693ZM193.245 152.409H156.287V152.338H193.245V152.409ZM193.245 152.125H156.287V152.054H193.245V152.125ZM193.245 151.841H156.287V151.77H193.245V151.841ZM193.245 151.557H156.287V151.486H193.245V151.557ZM193.245 151.273H156.287V151.202H193.245V151.273ZM193.245 150.918H156.287V150.847H193.245V150.918ZM193.245 150.634H156.287V150.563H193.245V150.634ZM193.245 150.35H156.287V150.208H193.245V150.35ZM193.245 150.066H156.287V149.924H193.245V150.066Z",
    fill: "#BAB9B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.684 77.376C105.684 77.376 105.755 79.8605 104.475 82.558C102.557 86.6043 97.6525 88.237 94.5964 87.7401C81.448 85.8944 80.8795 91.2184 80.9505 93.49C81.0216 95.7616 81.6613 100.589 81.6613 100.589C81.6613 100.589 75.4069 83.0549 87.4892 84.7586C101.917 86.7462 105.684 77.376 105.684 77.376Z",
    fill: "#543119"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.834 154.822L183.579 151.486C183.579 151.486 190.26 147.014 194.311 139.702C198.362 132.391 201.561 120.82 201.49 120.678C201.205 120.394 203.195 125.576 203.195 125.576C203.195 125.576 204.332 137.289 200.637 143.89C197.154 150.137 190.687 154.255 189.834 154.822Z",
    fill: "#406A7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.787 214.593L185.427 219.207C185.427 219.207 189.833 219.491 189.975 218.994C190.046 218.498 189.123 214.025 189.123 214.025L184.787 214.593Z",
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.137 223.821C169.436 226.022 170.644 228.152 170.644 228.152C170.644 228.152 174.198 229.145 177.61 229.074C181.732 229.003 186.565 226.661 186.565 226.661L186.422 227.868H191.966C191.966 227.868 193.174 225.241 192.393 222.473C191.611 219.704 190.331 218.213 190.331 218.213C190.331 218.213 186.28 218.852 185.427 218.639C184.575 218.426 181.234 221.763 179.528 222.473C177.894 223.253 173.914 222.473 172.137 223.821Z",
    fill: "#2A2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.573 227.939C170.644 228.081 170.644 228.152 170.644 228.152C170.644 228.152 174.198 229.145 177.609 229.074C181.731 229.003 186.564 226.661 186.564 226.661L186.422 227.868H191.966C191.966 227.868 192.534 226.732 192.605 225.17C192.534 224.886 192.534 224.602 192.392 224.318C191.61 221.479 190.331 220.059 190.331 220.059C190.331 220.059 186.28 220.698 185.427 220.485C184.574 220.272 181.234 223.608 179.528 224.318C177.822 225.028 173.842 224.176 172.066 225.596C171.213 226.519 170.786 227.3 170.573 227.939Z",
    fill: "#0B0E10"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.267 213.244L204.546 217.717C204.546 217.717 208.952 217.362 208.952 216.794C208.952 216.297 207.389 212.038 207.389 212.038L203.267 213.244Z",
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.037 224.176C189.692 226.732 191.184 228.72 191.184 228.72C191.184 228.72 194.88 229.217 198.22 228.649C202.342 228.01 206.749 224.957 206.749 224.957L206.82 226.164L212.293 225.383C212.293 225.383 213.145 222.615 211.937 219.988C210.729 217.362 209.236 216.084 209.236 216.084C209.236 216.084 205.328 217.291 204.475 217.22C203.622 217.149 200.779 220.911 199.215 221.905C197.652 222.757 193.601 222.544 192.037 224.176Z",
    fill: "#2A2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.113 228.436C191.184 228.578 191.255 228.72 191.255 228.72C191.255 228.72 194.951 229.217 198.292 228.649C202.414 228.01 206.82 224.957 206.82 224.957L206.891 226.164L212.364 225.383C212.364 225.383 212.577 224.603 212.648 223.396C212.577 222.97 212.435 222.615 212.222 222.189C211.014 219.562 209.521 218.285 209.521 218.285C209.521 218.285 205.612 219.491 204.759 219.42C203.906 219.349 201.063 223.112 199.5 224.106C197.936 225.028 193.885 224.815 192.322 226.448C191.611 227.158 191.255 227.868 191.113 228.436Z",
    fill: "#0B0E10"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.781 120.962C228.781 120.962 225.939 131.326 225.37 135.159C224.801 138.992 225.654 164.619 225.654 164.619C225.654 164.619 215.278 161.779 208.099 161.424C200.921 161.069 195.448 162.56 195.448 162.56C195.448 162.56 202.84 126.712 202.84 126.499C202.84 126.286 201.49 120.749 201.49 120.749C201.49 120.749 204.261 116.206 214.354 116.064C224.446 115.922 228.995 120.749 228.781 120.962Z",
    fill: "#406A7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.236 116.56L211.297 137.927L221.248 116.844C221.248 116.844 217.765 115.495 214.922 115.637C213.501 115.779 212.79 115.637 209.236 116.56Z",
    fill: "#31383C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.297 137.998L210.729 133.1L212.363 124.653C212.363 124.653 212.576 125.15 213.785 125.15C214.993 125.15 215.348 124.724 215.348 124.724L214.78 130.758L211.297 137.998Z",
    fill: "#557FB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.225 161.566C197.225 161.566 184.859 167.032 178.675 181.442C175.477 193.084 183.153 217.504 183.153 217.504L193.529 216.581C193.529 216.581 184.29 194.22 188.199 184.069C191.042 176.686 198.576 172.143 201.987 170.439C202.769 170.013 206.678 169.871 206.251 170.155C203.195 172.143 198.576 178.248 197.012 183.146C194.738 190.103 200.21 214.593 201.276 215.942C201.703 216.439 211.155 215.303 211.155 215.303C211.155 215.303 204.048 188.754 207.033 184.566C213.998 174.556 225.228 174.415 225.512 168.097C225.796 162.631 225.37 163.128 223.238 162.489C212.435 157.236 197.225 161.566 197.225 161.566Z",
    fill: "#638EA1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.691 166.606C187.417 168.594 184.858 171.149 182.584 174.486C185.214 173.989 187.275 174.983 189.62 175.976C187.275 178.461 186.138 179.739 183.792 182.223C181.589 183.572 179.883 183.643 178.391 182.862C176.045 194.93 183.153 217.504 183.153 217.504L193.529 216.581C193.529 216.581 184.29 194.22 188.199 184.069C191.042 176.686 198.575 172.143 201.987 170.439C202.769 170.014 206.678 169.872 206.251 170.156C204.759 171.078 202.982 172.995 201.276 175.267C206.109 174.841 210.515 175.267 213.785 177.893C219.542 173.918 225.298 172.498 225.512 168.097C225.796 162.631 225.37 163.128 223.237 162.489C222.882 162.347 218.831 157.165 218.404 157.023L211.084 161.708L189.691 166.606ZM196.514 187.121C196.23 196.634 200.423 214.806 201.347 215.942C201.56 216.226 203.906 216.013 206.322 215.8C203.408 206.643 201.276 196.989 201.418 185.773C199.499 187.192 197.936 187.547 196.514 187.121Z",
    fill: "#406A7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.552 119.258C217.41 120.607 215.847 121.53 214.141 121.317C212.435 121.104 211.156 119.826 211.298 118.477L211.795 114.644C211.938 113.295 213.501 112.372 215.207 112.585C216.913 112.798 218.192 114.076 218.05 115.425L217.552 119.258Z",
    fill: "#EE9C94"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.582 121.885L214.14 121.388L216.699 121.672L215.278 124.795L214.851 125.221C214.283 125.86 213.288 125.789 212.719 125.15L212.364 124.724L211.582 121.885Z",
    fill: "#45649F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.141 121.387C214.141 121.387 217.41 125.221 217.481 126.143C217.623 127.066 221.106 116.915 221.106 116.915C221.106 116.915 218.05 115.495 217.979 115.708C216.628 119.187 214.141 121.387 214.141 121.387Z",
    fill: "#4C494A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.211 121.317C214.211 121.317 210.445 123.73 210.16 124.582C209.876 125.505 209.876 116.277 209.876 116.277C209.876 116.277 211.653 115.638 211.653 115.851C211.653 117.767 214.211 121.317 214.211 121.317Z",
    fill: "#4C494A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.653 137.359L224.02 121.529L221.035 120.89C221.035 120.89 223.38 120.252 226.152 119.045C224.446 117.98 220.324 116.489 220.324 116.489L211.653 137.359Z",
    fill: "#638EA1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.298 137.998L205.185 120.962L208.241 120.394L204.475 118.548L209.734 116.418L211.298 137.998Z",
    fill: "#638EA1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.008 142.045C212.008 142.542 211.653 142.897 211.156 142.897C210.658 142.897 210.303 142.542 210.303 142.045C210.303 141.548 210.658 141.193 211.156 141.193C211.653 141.193 212.008 141.619 212.008 142.045Z",
    fill: "#31383C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.44 146.659C211.44 147.156 211.085 147.511 210.587 147.511C210.09 147.511 209.734 147.156 209.734 146.659C209.734 146.162 210.09 145.807 210.587 145.807C211.014 145.807 211.44 146.233 211.44 146.659Z",
    fill: "#31383C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.013 151.486C211.013 151.983 210.658 152.338 210.16 152.338C209.663 152.338 209.307 151.983 209.307 151.486C209.307 150.989 209.663 150.634 210.16 150.634C210.658 150.634 211.013 150.989 211.013 151.486Z",
    fill: "#A29899"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.051 102.292C232.264 103.854 231.198 105.345 229.705 105.558C228.142 105.771 225.37 105.274 225.085 103.712C224.872 102.15 227.289 100.092 228.852 99.8786C230.416 99.5947 231.837 100.73 232.051 102.292Z",
    fill: "#F6A399"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.999 102.15C227.502 109.249 221.674 116.063 214.353 116.063C207.033 116.063 201.489 109.249 201.489 102.15C201.489 95.0513 203.053 87.5977 210.373 87.5977C217.694 87.5267 229.065 85.823 227.999 102.15Z",
    fill: "#F6A399"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228 102.15C227.644 107.403 224.304 112.585 219.613 114.857C219.4 114.857 219.258 114.857 219.045 114.857C211.724 114.857 206.181 108.042 206.181 100.943C206.181 95.5484 207.105 89.9405 210.729 87.5979C218.05 87.5269 228.995 86.1072 228 102.15Z",
    fill: "#F9BCAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.897 100.66C219.684 100.66 219.471 100.518 219.399 100.305C218.973 99.0269 217.623 98.3171 216.343 98.743C216.059 98.814 215.775 98.672 215.633 98.388C215.562 98.1041 215.704 97.8201 215.988 97.6782C217.836 97.0393 219.826 98.0331 220.394 99.8788C220.466 100.163 220.323 100.447 220.039 100.589C219.968 100.66 219.968 100.66 219.897 100.66ZM203.977 100.305C203.906 100.305 203.835 100.305 203.693 100.234C203.408 100.092 203.337 99.7368 203.479 99.5238C204.403 97.8201 206.535 97.1813 208.241 98.1041C208.525 98.2461 208.596 98.601 208.454 98.814C208.312 99.0979 207.957 99.1689 207.744 99.0269C206.535 98.388 205.114 98.814 204.474 100.021C204.332 100.163 204.119 100.305 203.977 100.305Z",
    fill: "#331410"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.576 112.23C212.434 112.23 212.292 112.23 212.221 112.23C210.658 112.159 209.236 111.449 208.241 110.242C208.028 110.029 208.099 109.675 208.312 109.462C208.525 109.249 208.881 109.32 209.094 109.533C209.947 110.455 211.084 111.023 212.363 111.165C213.643 111.236 214.851 110.81 215.775 109.958C215.988 109.745 216.343 109.816 216.557 110.029C216.77 110.242 216.699 110.597 216.485 110.81C215.348 111.733 213.998 112.23 212.576 112.23ZM229.35 104.918C229.207 104.918 228.994 104.918 228.852 104.847C228.568 104.776 228.426 104.492 228.497 104.209C228.568 103.925 228.852 103.783 229.136 103.854C229.563 103.996 230.06 103.712 230.202 103.286C230.345 102.86 230.131 102.363 229.705 102.221C229.421 102.079 229.278 101.795 229.421 101.511C229.563 101.227 229.847 101.085 230.131 101.227C231.055 101.582 231.553 102.647 231.268 103.641C230.913 104.421 230.131 104.918 229.35 104.918Z",
    fill: "#ED7660"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.886 102.221C207.886 103.144 207.389 103.925 206.82 103.925C206.251 103.925 205.754 103.144 205.754 102.221C205.754 101.298 206.251 100.518 206.82 100.518C207.46 100.518 207.886 101.298 207.886 102.221Z",
    fill: "#3B150E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.891 101.369C206.891 101.653 206.749 101.866 206.536 101.866C206.323 101.866 206.181 101.653 206.181 101.369C206.181 101.085 206.323 100.872 206.536 100.872C206.749 100.872 206.891 101.085 206.891 101.369Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.618 102.221C218.618 103.144 218.12 103.925 217.551 103.925C216.983 103.925 216.485 103.144 216.485 102.221C216.485 101.298 216.983 100.518 217.551 100.518C218.12 100.589 218.618 101.298 218.618 102.221Z",
    fill: "#3B150E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.623 101.582C217.623 101.866 217.481 102.079 217.267 102.079C217.054 102.079 216.912 101.866 216.912 101.582C216.912 101.298 217.054 101.085 217.267 101.085C217.41 101.014 217.623 101.298 217.623 101.582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.363 106.551C212.292 106.551 212.15 106.551 212.079 106.551C211.084 106.409 210.373 105.486 210.444 104.493C210.444 104.209 210.729 103.996 211.013 103.996C211.297 103.996 211.51 104.28 211.51 104.564C211.439 104.989 211.795 105.415 212.221 105.486C212.505 105.486 212.719 105.415 212.932 105.273C213.145 105.06 213.5 105.06 213.714 105.273C213.927 105.486 213.927 105.841 213.714 106.054C213.287 106.338 212.79 106.551 212.363 106.551Z",
    fill: "#ED7660"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.268 88.4495C230.771 85.9649 228.568 84.2612 226.009 84.2612C225.369 84.2612 224.659 84.2612 223.877 84.1903C223.735 84.1903 223.664 84.1903 223.521 84.1903C223.166 84.1193 220.181 81.8477 217.551 80.9249C216.912 80.7119 216.912 82.2026 216.272 81.9187C213.856 80.8539 211.51 79.0792 210.871 79.0082C209.52 78.7953 209.165 82.1316 208.454 81.9187C207.672 81.6347 203.408 78.0144 202.839 77.8014C201.844 77.4465 201.702 81.0668 201.773 85.0421C201.773 85.468 200.778 85.823 200.778 86.2489C200.92 90.863 202.058 96.116 202.058 96.116C202.058 96.116 203.408 89.2303 208.312 90.2951C210.657 90.792 213.571 92.5667 217.267 91.7149C219.186 91.2889 221.46 90.6501 222.811 90.792C224.588 90.934 226.009 92.1408 226.578 93.7735C226.72 94.1284 226.791 94.5543 226.862 94.9803C227.004 97.1809 226.08 100.233 225.938 101.866C225.867 102.576 227.004 103.215 227.075 103.215C227.715 103.57 227.999 101.369 228.852 100.588C229.776 99.7364 230.202 100.091 230.202 100.091C230.202 100.091 231.695 97.0389 231.695 92.4247C231.695 91.005 231.553 89.6562 231.268 88.4495Z",
    fill: "#2F1210"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.195 78.3696C203.195 78.3696 203.124 80.8542 204.404 83.5517C206.322 87.5269 211.226 89.2306 214.283 88.7337C227.431 86.888 228 92.2121 227.928 94.4836C227.857 96.7552 227.218 101.582 227.218 101.582C227.218 101.582 233.472 84.0486 221.39 85.7523C206.962 87.7399 203.195 78.3696 203.195 78.3696Z",
    fill: "#543119"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8195 105.699C91.2559 105.699 89.9055 104.492 89.8345 102.931L79.9554 99.8072C79.8133 99.7362 79.7422 99.5943 79.7422 99.4523C79.8133 99.3103 79.9554 99.2393 80.0975 99.2393L89.8345 102.292C90.0477 100.801 91.2559 99.6653 92.8195 99.6653C94.0277 99.6653 95.0938 100.446 95.5913 101.511C96.0888 101.085 96.7285 100.872 97.297 100.872C97.8656 100.872 98.3631 101.085 98.7185 101.369C99.1449 100.233 100.211 99.4523 101.49 99.4523C102.699 99.4523 103.765 100.162 104.191 101.227L106.963 97.3227C107.034 97.1807 107.247 97.1807 107.318 97.2517C107.46 97.3227 107.46 97.5357 107.389 97.6066L104.404 101.795C104.475 102.008 104.475 102.221 104.475 102.434C104.475 104.066 103.125 105.415 101.49 105.415C99.8557 105.415 98.5053 104.066 98.5053 102.434C98.5053 102.292 98.5053 102.079 98.5764 101.937C98.221 101.582 97.7946 101.369 97.297 101.369C96.7285 101.369 96.1599 101.582 95.7335 102.008C95.8045 102.221 95.8045 102.434 95.8045 102.647C95.8045 104.35 94.4542 105.699 92.8195 105.699ZM90.332 102.718C90.332 104.066 91.3981 105.131 92.8195 105.131C94.1699 105.131 95.236 103.995 95.236 102.647C95.236 101.298 94.1699 100.162 92.8195 100.162C91.4691 100.233 90.332 101.298 90.332 102.718ZM101.561 100.02C100.211 100.02 99.0739 101.156 99.0739 102.434C99.0739 103.782 100.14 104.918 101.561 104.918C102.912 104.918 104.049 103.782 104.049 102.434C104.049 101.156 102.912 100.02 101.561 100.02Z",
    fill: "#232E30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.9 149.64C191.042 148.93 188.128 146.446 187.701 146.73C187.417 145.452 186.777 145.168 186.209 144.955C186.138 144.955 186.422 145.594 186.28 145.594C185.996 145.594 185.072 144.813 184.787 144.884L184.574 145.452L183.295 144.458L183.935 148.22C185.143 148.717 186.28 150.35 187.133 151.77C187.204 152.125 187.844 154.396 187.915 154.254C188.057 154.112 189.691 154.183 190.189 153.544C190.686 152.905 191.326 152.267 192.108 152.196L193.6 148.859L190.9 149.64Z",
    fill: "#E9938B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.103 155.248C190.687 153.403 189.408 150.279 190.118 147.227C190.616 145.097 191.895 143.393 193.672 142.329C195.378 141.264 197.581 140.838 199.784 141.335C201.987 141.832 203.764 143.11 204.83 144.813C205.967 146.517 206.394 148.647 205.896 150.776C205.47 152.693 204.333 154.325 202.84 155.39C201.348 156.455 199.429 157.023 197.51 156.881L197.368 159.295C199.926 159.507 202.343 158.727 204.262 157.307C206.181 155.887 207.673 153.829 208.242 151.273C208.881 148.505 208.313 145.736 206.82 143.464C205.399 141.264 203.053 139.56 200.282 138.921C197.51 138.282 194.667 138.85 192.393 140.27C190.118 141.69 188.413 143.961 187.773 146.73C186.849 150.776 188.555 154.822 191.682 157.236L193.103 155.248Z",
    fill: "#803628"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.468 148.291H187.204V146.659H191.468V148.291Z",
    fill: "#918E8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.829 148.291H186.493V146.659H190.829V148.291Z",
    fill: "#C8C1C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.734 148.291H205.469V146.659H209.734V148.291Z",
    fill: "#918E8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.094 148.291H204.83V146.659H209.094V148.291Z",
    fill: "#C8C1C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.234 148.079H220.253V162.915H218.618V173.137H181.234V148.079Z",
    fill: "#551911"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.619 151.77C175.619 149.711 177.254 148.079 179.315 148.079H220.395C220.395 148.079 218.263 148.221 217.268 148.717C216.273 149.214 216.344 151.202 216.344 151.202V162.347H214.211V173.066H180.736C178.888 173.066 177.396 171.575 177.396 169.73V162.276L175.619 162.063V151.77Z",
    fill: "#803628"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.315 151.415H216.415V151.344C216.415 151.344 216.273 149.356 217.339 148.86C218.334 148.363 220.466 148.221 220.466 148.221H179.386C177.325 148.221 175.691 149.853 175.691 151.912V155.177C175.62 153.048 177.254 151.415 179.315 151.415Z",
    fill: "#9B4F45"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.182 162.915H177.396V162.418H220.182V162.915Z",
    fill: "#3C130F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.647 165.399H194.595V160.359H198.647V165.399Z",
    fill: "#918E8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.936 165.399H193.813V160.359H197.936V165.399Z",
    fill: "#C8C1C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.012 164.69H194.453V161.069H197.012V164.69Z",
    fill: "#918E8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.443 163.909H195.093V161.708H196.443V163.909Z",
    fill: "#C8C1C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.678 152.906C206.678 152.906 209.023 151.131 209.379 150.634C209.663 150.208 209.379 147.582 209.379 147.582C209.379 147.582 209.308 146.801 207.815 149.995C206.891 151.983 205.541 153.19 206.678 152.906Z",
    fill: "#E08077"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.552 145.381C217.552 145.381 216.13 145.452 214.496 145.736C212.79 146.02 212.008 146.304 212.008 146.304C212.008 146.304 211.013 146.517 210.16 146.73C209.308 146.872 208.81 149.285 208.81 149.285C208.81 149.285 208.241 153.118 208.17 153.686C208.099 154.254 208.668 154.112 209.165 153.828C209.734 153.473 210.16 151.131 210.16 150.421C210.231 149.711 210.374 152.693 210.16 153.331C209.876 153.899 211.298 153.757 211.582 152.409C211.866 150.989 212.293 149.356 212.293 149.356C212.293 149.356 213.288 149.498 213.572 149.427C213.856 149.356 216.557 149.498 217.125 149.569C219.4 150.208 219.755 148.717 221.106 148.291L222.243 145.736L217.552 145.381Z",
    fill: "#F6A399"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.742 141.264C238.66 156.029 221.106 152.054 221.106 152.054L220.182 144.174C220.182 144.174 226.294 146.091 228.995 143.393C230.274 136.862 226.436 133.171 223.38 129.338C223.096 129.338 228.213 120.394 228.213 120.394C228.213 120.394 235.32 132.177 236.742 141.264Z",
    fill: "#406A7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.742 141.264C237.026 143.535 236.884 145.31 236.386 146.801C232.406 151.486 223.451 150.421 220.893 149.995L220.253 144.245C220.253 144.245 225.157 146.162 229.066 143.464C232.833 140.98 230.274 134.165 224.802 127.279C223.38 123.304 226.721 117.838 228.213 120.465C228.284 120.465 235.32 132.177 236.742 141.264Z",
    fill: "#638EA1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.717 149.782C185.783 149.569 186.707 147.085 186.92 146.659C187.133 146.233 186.209 144.955 186.209 144.955C186.209 144.955 186.067 144.316 185.214 147.227C184.717 148.93 183.722 149.924 184.717 149.782Z",
    fill: "#F6A399"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.387 149.143C180.595 149.427 182.869 147.226 183.295 146.871C183.722 146.517 183.367 144.671 183.367 144.671C183.367 144.671 183.509 143.89 181.163 146.659C179.813 148.22 178.249 148.859 179.387 149.143Z",
    fill: "#E9938B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.163 150.137C182.443 149.995 183.793 147.085 184.006 146.659C184.29 146.162 183.295 144.6 183.295 144.6C183.295 144.6 183.153 143.819 181.945 147.227C181.305 149.143 180.026 150.208 181.163 150.137Z",
    fill: "#E9938B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.442 149.853C183.579 149.782 185.072 147.227 185.285 146.801C185.569 146.375 184.788 144.813 184.788 144.813C184.788 144.813 184.717 144.032 183.366 147.156C182.655 148.931 181.376 149.924 182.442 149.853Z",
    fill: "#F6A399"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.878 148.788C223.878 149.285 223.522 149.64 223.025 149.64C222.527 149.64 222.172 149.285 222.172 148.788C222.172 148.291 222.527 147.937 223.025 147.937C223.522 147.937 223.878 148.291 223.878 148.788Z",
    fill: "#31383C"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8621 156.597H66.2387L68.8683 141.619H53.2324L55.8621 156.597Z",
    fill: "#825A24"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.492 156.597H68.8685L71.4982 141.619H55.8623L58.492 156.597Z",
    fill: "#B57F42"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8262 123.73C50.2477 118.548 46.2676 114.431 37.9522 116.064C42.2165 116.844 43.4958 121.388 43.9933 124.653C43.4247 125.363 43.3537 125.434 42.714 126.144C42.643 122.026 41.0794 119.187 36.6729 116.419C34.0432 117.412 31.9821 119.116 29.6367 120.607C34.0432 120.891 38.0233 125.221 39.4447 129.622C38.8761 130.19 38.3075 130.758 37.739 131.326C35.4646 126.783 32.1953 123.375 28.5706 121.53C27.3624 122.736 25.4435 126.002 24.5906 127.421C28.7838 127.067 32.5507 129.409 35.1804 133.81C34.6829 134.236 34.9671 134.023 34.4696 134.52C31.3425 130.971 27.2913 129.835 23.7377 129.48C23.3113 130.687 22.9559 131.894 22.6716 133.171C25.6567 133.597 28.5706 134.875 31.4135 137.218C30.9871 137.644 30.4896 138.07 29.9921 138.495C27.1492 137.005 24.5195 136.366 22.032 136.437C21.8188 137.573 21.6766 138.779 21.4634 139.986C23.2402 140.128 25.017 140.483 26.936 141.193C26.3674 141.69 26.4385 141.619 25.7988 142.187C24.7327 141.619 22.9559 141.69 21.108 142.755C20.8948 144.032 20.6816 145.31 20.4684 146.588C19.118 154.184 15.138 153.9 25.0881 149.285C25.5856 149.072 26.0831 148.789 26.5806 148.647C27.5756 145.949 27.7888 144.245 26.8649 142.897C27.3624 142.329 27.3624 142.329 27.8599 141.832C28.6417 144.103 29.5656 145.594 29.5656 147.582C30.7739 147.227 31.9821 146.943 33.1193 146.73C33.2614 144.174 32.3375 141.761 30.8449 138.779C30.8449 138.779 31.4846 138.07 31.911 137.715C34.2564 140.838 35.3936 142.471 34.8961 146.517C36.1754 146.375 39.0183 146.162 40.2265 146.091C39.9422 142.471 38.5918 138.566 34.8961 134.946C35.3936 134.52 35.1804 134.591 35.6068 134.094C40.4397 137.573 43.3537 141.264 44.5619 145.594C46.0544 145.381 49.0395 144.387 50.532 143.677C49.1816 138.921 44.9883 134.378 39.4447 130.971C40.0133 130.474 39.729 130.687 40.2976 130.19C46.1255 132.746 50.7452 137.005 53.4459 141.69C54.2988 141.051 55.2228 140.27 56.0756 139.347C56.2888 139.205 57.2838 138.141 57.4971 137.999C55.1517 133.384 49.1816 130.119 42.9272 127.705C43.638 127.138 43.2826 127.421 43.9933 126.925C51.9534 127.989 55.9335 131.184 58.8474 136.579C65.9547 126.357 54.512 122.239 48.8262 123.73Z",
    fill: "#A0BF48"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.834 152.48C19.4026 152.267 21.1083 151.06 25.1594 149.214C25.6569 149.001 26.1544 148.718 26.6519 148.576C27.5759 146.162 27.7891 144.529 27.2205 143.252C24.3066 146.02 21.4637 149.143 18.834 152.48ZM28.1445 142.329C28.8552 144.245 29.637 145.665 29.637 147.511C30.8452 147.156 32.0534 146.872 33.1906 146.659C33.3327 144.387 32.5509 142.187 31.2716 139.489C30.2766 140.412 29.2105 141.335 28.1445 142.329ZM32.622 138.424C34.541 140.98 35.4649 142.684 34.9674 146.375C36.2467 146.233 39.0896 146.02 40.2978 145.949C40.0135 142.684 38.8764 139.205 36.0335 135.869C34.8963 136.65 33.7592 137.502 32.622 138.424ZM37.1706 135.088C41.1507 138.211 43.5672 141.619 44.6332 145.523C46.1258 145.31 49.1108 144.316 50.6033 143.606C49.4662 139.489 46.1258 135.514 41.6482 132.32C40.1557 133.171 38.6632 134.094 37.1706 135.088ZM43.2118 131.539C47.7604 134.094 51.3851 137.715 53.5883 141.619C54.4412 140.98 55.3652 140.199 56.218 139.276C56.4312 139.134 57.4263 138.07 57.6395 137.928C55.8627 134.449 52.0248 131.752 47.6183 129.622C46.1258 130.119 44.6332 130.829 43.2118 131.539ZM50.6744 128.557C54.5123 130.19 56.9998 132.816 58.9188 136.508C61.6906 132.533 61.5484 129.48 60.0559 127.35C57.0709 127.209 53.9437 127.634 50.6744 128.557Z",
    fill: "#85AB43"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M62.97 141.69L61.3353 141.548C62.1171 130.829 60.7668 123.801 57.3553 121.813C55.2942 120.607 52.3802 121.175 48.6134 123.517L47.6895 122.097C51.9538 119.329 55.5074 118.761 58.1371 120.323C62.2593 122.736 63.8229 129.906 62.97 141.69Z",
    fill: "#A0BF48"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3711 113.366C67.5182 110.172 69.9347 107.687 75.0519 108.681C72.4222 109.178 71.6404 111.946 71.3561 113.934C71.7115 114.36 71.7825 114.431 72.1379 114.857C72.1379 112.301 73.1329 110.597 75.8337 108.894C77.4683 109.462 78.6766 110.526 80.1691 111.449C77.4683 111.591 75.0519 114.289 74.1279 116.986C74.4833 117.341 74.8387 117.696 75.194 118.051C76.6155 115.283 78.6055 113.153 80.8087 112.017C81.5905 112.798 82.7277 114.786 83.2252 115.637C80.6666 115.425 78.3212 116.844 76.6865 119.542C76.9708 119.826 76.8287 119.684 77.113 119.968C79.0319 117.767 81.5194 117.128 83.7227 116.844C84.007 117.554 84.2202 118.335 84.3623 119.116C82.5145 119.4 80.7376 120.181 78.9608 121.6C79.2451 121.884 79.5294 122.097 79.8137 122.381C81.5194 121.458 83.1541 121.033 84.7177 121.103C84.8598 121.813 84.9309 122.523 85.0731 123.304C84.007 123.375 82.8698 123.588 81.7327 124.014C82.088 124.298 82.017 124.298 82.4434 124.582C83.1541 124.227 84.2202 124.298 85.3573 124.937C85.4995 125.718 85.5706 126.498 85.7127 127.279C86.5656 131.964 88.982 131.752 82.8698 128.912C82.5855 128.77 82.2302 128.628 81.9459 128.486C81.3062 126.853 81.2352 125.789 81.8037 124.937C81.4484 124.582 81.5194 124.582 81.1641 124.298C80.6666 125.647 80.098 126.64 80.098 127.847C79.3162 127.634 78.6055 127.492 77.8948 127.35C77.8237 125.789 78.3923 124.298 79.3162 122.452C79.3162 122.452 78.8898 122.026 78.6766 121.813C77.2551 123.73 76.5444 124.724 76.8287 127.208C76.0469 127.137 74.2701 126.995 73.5593 126.924C73.7726 124.724 74.5544 122.31 76.8287 120.11C76.5444 119.826 76.6865 119.897 76.4022 119.613C73.4172 121.742 71.6404 124.014 70.9297 126.64C70.0057 126.498 68.2289 125.86 67.2339 125.505C68.0157 122.594 70.6454 119.755 74.0569 117.696C73.7015 117.341 73.8436 117.554 73.4883 117.199C69.9347 118.761 67.0207 121.387 65.4571 124.227C64.9596 123.801 64.391 123.375 63.8224 122.807C63.6803 122.665 63.0406 122.097 62.9696 121.955C64.391 119.116 68.0868 117.057 71.9247 115.637C71.4982 115.283 71.7115 115.425 71.285 115.141C66.381 115.779 63.9646 117.767 62.1878 121.103C57.8524 114.928 64.8885 112.443 68.3711 113.366Z",
    fill: "#A0BF48"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2693 125.931C58.0661 117.838 58.2793 112.798 60.909 110.811C62.8279 109.391 65.7419 109.888 69.2244 112.088L68.3005 113.508C65.5287 111.733 63.1833 111.237 61.904 112.159C59.914 113.579 59.914 118.477 61.8329 125.505L60.2693 125.931Z",
    fill: "#A0BF48"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9136 115.851L58.7764 115.567C60.9086 107.829 60.6243 102.008 57.9946 100.092C56.5021 98.9557 54.2988 99.2397 51.7402 100.872L51.1006 99.8786C54.0146 97.9619 56.7153 97.749 58.6343 99.1687C61.7614 101.369 62.1879 107.474 59.9136 115.851Z",
    fill: "#A0BF48"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4559 100.305C53.1617 98.3879 52.3088 95.7614 48.3998 94.7676C50.0345 95.9744 49.6791 98.2459 49.1816 99.7367C48.7552 99.8786 48.7552 99.9496 48.3287 100.092C49.1816 98.3169 49.0395 96.7552 47.7602 94.6256C46.4098 94.4836 45.2016 94.7676 43.8512 94.9806C45.6991 96.0454 46.4809 98.7428 46.1966 100.943C45.8412 101.085 45.4859 101.227 45.1305 101.298C45.1305 98.8848 44.4198 96.6842 43.2115 95.1935C42.4297 95.4775 40.9372 96.4713 40.2976 96.8972C42.2165 97.6071 43.2826 99.3817 43.4958 101.866C43.2115 101.937 43.3537 101.937 42.9983 102.008C42.3587 99.8077 40.8661 98.4589 39.4447 97.6071C39.0183 98.033 38.5918 98.5299 38.2365 99.0268C39.4447 99.8077 40.4397 101.014 41.1504 102.647C40.8661 102.718 40.5819 102.789 40.2976 102.931C39.3736 101.724 38.3786 100.872 37.3125 100.376C36.9572 100.801 36.6729 101.298 36.3175 101.795C37.0282 102.221 37.739 102.789 38.4497 103.428C38.0943 103.499 38.1654 103.499 37.739 103.641C37.3836 103.144 36.6018 102.86 35.6068 102.86C35.2514 103.357 34.8961 103.854 34.5407 104.422C32.3375 107.403 30.7028 106.48 35.9622 106.551C36.2464 106.551 36.5307 106.551 36.744 106.551C37.739 105.629 38.1654 104.919 38.0943 104.138C38.4497 103.996 38.4497 103.996 38.734 103.925C38.5918 105.061 38.6629 105.913 38.2365 106.764C38.8761 106.835 39.3736 106.977 39.9422 107.119C40.5108 106.054 40.6529 104.848 40.6529 103.215C40.6529 103.215 41.0794 103.073 41.3637 103.002C41.719 104.848 41.8612 105.771 40.7951 107.403C41.3637 107.616 42.643 108.113 43.2115 108.326C43.8512 106.693 44.0644 104.777 43.2826 102.434C43.5669 102.363 43.4958 102.292 43.7801 102.221C45.1305 104.706 45.628 106.906 45.2016 109.036C45.9123 109.249 47.4048 109.462 48.1866 109.462C48.613 107.119 47.7602 104.28 46.0544 101.653C46.4098 101.582 46.2676 101.582 46.623 101.511C48.613 103.854 49.6791 106.622 49.8923 109.178C50.3898 109.036 50.9584 108.894 51.527 108.752C51.6691 108.681 52.3088 108.468 52.4509 108.468C52.3799 105.984 50.532 103.286 48.3287 101.014C48.7552 100.943 48.542 100.943 48.9684 100.872C52.1666 103.002 53.2327 105.203 53.3038 108.113C58.2789 104.99 54.2277 100.872 51.4559 100.305Z",
    fill: "#A0BF48"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6882 105.274C32.0536 106.977 31.4139 106.338 35.9625 106.338C36.2468 106.338 36.5311 106.338 36.7443 106.338C37.7394 105.416 38.1658 104.706 38.0947 103.925C36.389 104.28 34.8965 104.706 33.6882 105.274ZM38.6633 103.854C38.5212 104.919 38.5922 105.7 38.2369 106.551C38.8765 106.622 39.374 106.764 39.9426 106.906C40.4401 105.984 40.5823 104.919 40.6533 103.57C39.9426 103.641 39.3029 103.712 38.6633 103.854ZM41.4351 103.57C41.6483 104.919 41.6483 105.771 40.7244 107.19C41.293 107.403 42.5723 107.9 43.1409 108.113C43.6384 106.835 43.9226 105.274 43.5673 103.499C42.8566 103.499 42.1458 103.499 41.4351 103.57ZM44.4202 103.499C45.202 105.416 45.4152 107.119 45.1309 108.823C45.8416 109.036 47.3341 109.178 48.1159 109.249C48.4002 107.616 48.0448 105.629 47.263 103.712C46.5523 103.641 45.7705 103.57 44.9887 103.499C44.7755 103.57 44.5623 103.499 44.4202 103.499ZM48.2581 103.854C49.182 105.558 49.6795 107.332 49.7506 108.965C50.2481 108.823 50.8167 108.681 51.3852 108.539C51.5274 108.468 52.167 108.255 52.3092 108.255C52.3092 106.977 51.8117 105.7 51.0299 104.422C50.1059 104.209 49.182 103.996 48.2581 103.854ZM52.5224 104.848C52.8778 105.771 53.091 106.835 53.1621 107.971C54.2281 107.332 54.9389 106.693 55.2942 105.984C54.5124 105.558 53.5885 105.132 52.5224 104.848Z",
    fill: "#85AB43"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutusCircle1);
export default __webpack_public_path__ + "static/media/aboutus_circle_1.e2dea4308c4d6e1b94f2913b0c34847b.svg";
export { ForwardRef as ReactComponent };